
export const GET_DOCUMENTS = 'GET_DOCUMENTS';
export const GET_DOCUMENTS_FAIL = 'GET_DOCUMENTS_FAIL';
export const GET_DOCUMENTS_SUCCESS = 'GET_DOCUMENTS_SUCCESS';




// WEBPACK FOOTER //
// ./src/types/document.js